import * as prismic from '@prismicio/client';

// Reemplaza con el nombre de tu repositorio de Prismic
export const repositoryName = 'gbmedia';

// Configuración opcional de rutas para simplificar el link resolving
const routes = [
  {
    type: 'page',
    path: '/:uid',
  },
];

export const client = prismic.createClient(repositoryName, {
  routes,
  // Si tu repositorio es privado o requieres un Access Token, colócalo aquí:
  // accessToken: '',
});
